import type { Revision } from '../../../types';
import { RevisionIssueScanState } from '../../../types';

const getCommitStatus = (revision: Revision): RevisionIssueScanState => {
  if (revision && revision.resolved) {
    const isScanProvided = revision.meta ? !!revision.meta[0] : true;
    if (isScanProvided) {
      // if a scan was submitted (manually or automatically), prefer Passing/Failing state over NeedsConfiguration
      return revision.unresolved_issue_count > 0 ? RevisionIssueScanState.IssuesFound : RevisionIssueScanState.Passing;
    }
    if (revision.error || revision.unsupported) {
      return RevisionIssueScanState.NeedsConfiguration;
    }
  }
  return RevisionIssueScanState.Waiting;
};

export default getCommitStatus;
